var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","width":"100%"}},[_vm._m(0),_vm._v(" "),_c('a-carousel',{staticClass:"title_loop",attrs:{"dot-position":_vm.dotPosition,"autoplay":_vm.autoplay,"dots":"false"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"title_loop_content"},[_c('div',[_c('router-link',{attrs:{"tag":"span","to":{
              path: '/scNewsDetail',
              query: {
                newsId: item.newsId,
                navText: item.newsTitle,
                title: item.newsTitle,
                source: item.source,
                createBy: item.createBy,
                newsTitle: item.newsTitle,
                urlAddress: item.urlAddress,
              },
            }}},[_vm._v("\n            "+_vm._s(item.newsTitle))])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"tag":"span","to":{
              path: '/scNewsDetail',
              query: {
                newsId: item.newsId,
                navText: item.newsTitle,
                title: item.newsTitle,
                source: item.source,
                createBy: item.createBy,
                newsTitle: item.newsTitle,
                urlAddress: item.urlAddress,
              },
            }}},[_vm._v("\n            "+_vm._s(item.sNewsTitle))])],1)])}),0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("../../../static/img/index/announcement.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c395847a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/indexComp/indexContentTop.vue
// module id = null
// module chunks = 